import DupeResolver from './DupeResolver';

export default DupeResolver;
